import { Navigate, useLocation, useParams } from 'react-router';

type LegacyRouteRedirectProps = {
	to: string;
	query?: Record<string, string>;
};

/** Keep bookmarked filters and fragments when a page moves to its canonical route. */
export default function LegacyRouteRedirect({ to, query = {} }: LegacyRouteRedirectProps) {
	const location = useLocation();
	const params = useParams();
	const search = new URLSearchParams(location.search);
	Object.entries(query).forEach(([key, value]) => search.set(key, value));
	const pathname = to.replace(/:([a-zA-Z]+)/g, (_, key: string) => encodeURIComponent(params[key] ?? ''));

	return (
		<Navigate
			to={{ pathname, search: search.toString(), hash: location.hash }}
			state={location.state}
			replace
		/>
	);
}
